import { AdminTemplate, MerchantIBANListingTable } from "../../components";
import { useState, useCallback } from "react";
import { AddMerchantBankModal } from "../../components/organisms/merchant/AddMerchantBankModal";

export const MerchantIBANList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0); // State to trigger data refresh

  const handleSaveSuccess = useCallback(() => {
    setRefreshTrigger(prev => prev + 1); // Increment to trigger refresh in table
  }, []);

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "İşyeri Banka IBAN Listeleme",
        hideAddButton: true
      }}
    >
      <MerchantIBANListingTable onRowClick={() => { }} refreshTrigger={refreshTrigger} />
    </AdminTemplate>
  );
};
